import { gql } from '@apollo/client'
import { DomainEntityChangedEvent } from 'share/domain/subscription'

export const SUBSCRIBE_DOMAIN_ENTITY_CHANGED_EVENT = gql`
  subscription SUBSCRIBE_DOMAIN_ENTITY_CHANGED_EVENT($accountId: Int!) {
    domainEntityChangedEvent(accountId: $accountId) {
      accountId
      caseId
      domainEntityId
      domainEntityType
      parameter1
      parameter2
    }
  }
`

export interface SubscribeDomainEntityChangedEventVariables {
  accountId: number
}

export interface SubscribeDomainEntityChangedEventResponse {
  domainEntityChangedEvent: DomainEntityChangedEvent
}
